import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2c9632de"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "process-tenants-payment-filters" }
const _hoisted_2 = { class: "grid-menu-container" }
const _hoisted_3 = { class: "payments-grid-container" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["onMouseover"]
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["onMouseover"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "warnings-cell" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "total-fields" }
const _hoisted_12 = { class: "total-field-pairs" }
const _hoisted_13 = { class: "total-field-pairs" }

import { PaymentRunListItem } from "@/types/accounts/PaymentRunListItem";
import { PropType, ref, nextTick, computed, onMounted } from "vue";
import { formatNumberIntoCurrency } from "@/utils/CurrencyFormatter";
import GridBase from "@/components/ui/grid/grid-base.vue";
import { DxColumn } from "devextreme-vue/data-grid";
import { CurrentUser } from "@/types/user/CurrentUser";
import ContactsPeekPopup from "@/components/contacts/contacts-peek-popup.vue";
import PropertyPeekModal from "@/components/properties/property-peek-modal.vue";
import { FieldSize } from "@/enums/system/FieldSize";
import { useCurrentUserStore } from "@/stores/CurrentUserStore";
import { PaymentRunContactAPIFilters } from "@/types/accounts/PaymentRunContactAPIFilters";
import { DefaultContactType } from "acquaint-api/constants/DefaultContactType";
import { CodeType } from "acquaint-api/constants/CodeType";
import SystemCodeSingleSelect from "@/components//ui/system-codes/system-code-single-select.vue";
import ContactLookup from "@/components/ui/lookup/contact-lookup.vue";
import FieldValidationFreeDateBox from "@/components/ui/inputs/field-validation-free-date-box.vue";
import LookupSingleSelect from "@/components/ui/lookup/lookup-single-select.vue";
import { LookupTableSource } from "acquaint-api/constants/LookupTableSource";
import { ContextMenuItem } from "@/types/ui/menus/ContextMenuItem";
import AcquaintInfoBox from "@/components/ui/inputs/acquaint-info-box.vue";
import SwitchToggle from "@/components/ui/toggles/switch-toggle.vue";
import GridMenu from "@/components/ui/grid/grid-menu.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'payment-run-step-one',
  props: {
  /**
   * The boolean value used with `v-model` to control the visibility or state of a modal or component.
   * @type {array as PaymentRunListItem[]}
   * @required
   */
  payments: {
    type: Array as PropType<PaymentRunListItem[]>,
    required: true,
  },
  /**
   * Grid displays a rotating spinner while loading.
   * @type {boolean}
   * @required
   */
  loading: {
    type: Boolean,
    required: true,
  },
  /**
   * The boolean value used with `v-model` to control whether or not the grid should be exported to an excel file.
   * @type {boolean}
   * @required
   */
  exportGrid: {
    type: Boolean,
    required: true,
  },
  /**
   * Set to true if the payment processing is successful.
   * @type {boolean}
   * @required
   */
  processSuccessful: {
    type: Boolean,
    required: true,
  },
  /**
   * The filters with `v-model` that are sent to the list endpoint.
   * @type {Object as PaymentRunContactAPIFilters}
   * @required
   */
  filters: {
    type: Object as PropType<PaymentRunContactAPIFilters>,
    required: true,
  },
  /**
   * The selected payment method used to process the payments.
   * @type {number}
   * @required
   */
  paymentMethod: {
    type: Number,
    required: true,
  },
  /**
   * The selected payment date used to process the payments.
   * @type {string}
   * @required
   */
  paymentDate: {
    type: String,
    required: true,
  },
  /**
   * The boolean value used with `v-model` to control the visibility or state of a modal or component.
   * @type {array as ContextMenuItem[]}
   * @required
   */
  menuItems: {
    type: Array as PropType<ContextMenuItem[]>,
    required: true,
  },
},
  emits: [
  /**
   * Triggered when the `exportGrid` changes. This is used export the grid to excel and download it locally for the user.
   * @property {boolean} value - Indicates whether or not the grid should be exported.
   */
  "update:exportGrid",
  /**
   * Triggered when a row is single clicked so the selected row ref can be set in the parent component.
   */
  "rowSingleClick",
  /**
   * Triggered when a row is double clicked so the selected row ref can be set in the parent component.
   */
  "rowDoubleCLick",
  /**
   * Triggered when the `filters` changes. This is used to update the displayed payments and contacts.
   * @property {Object as PaymentRunContactAPIFilters} value
   */
  "update:filters",
  /**
   * Triggered when the `paymentMethod` changes. This is used to update the v-model variable in the parent component.
   * @property {number} value
   */
  "update:paymentMethod",
  /**
   * Triggered when the `paymentDate` changes. This is used to update the v-model variable in the parent component.
   * @property {string} value
   */
  "update:paymentDate",
  /**
   * Triggered when the a bank account is selected, so the parent can access its description  for processing the payments.
   */
  "bankAccountSelected",
  /**
   * Triggered when the a contact type is selected, so the parent can access its description for processing the payments.
   */
  "contactTypeSelected",
  /**
   * Triggered when the a menu item is selected.
   * @property {ContextMenuItem} value
   */
  "menuItemSelected",
],
  setup(__props, { emit }) {

const props = __props;





const exportGrid = computed({
  get: () => props.exportGrid,
  set: (value: boolean) => emit("update:exportGrid", value),
});

const selectedFilters = computed({
  get: () => props.filters,
  set: (value: PaymentRunContactAPIFilters) => emit("update:filters", value),
});

const paymentMethod = computed({
  get: () => props.paymentMethod,
  set: (value: number) => emit("update:paymentMethod", value),
});

const paymentDate = computed({
  get: () => props.paymentDate,
  set: (value: string) => emit("update:paymentDate", value),
});

const currentUserStore = useCurrentUserStore();
const currentUser = ref<CurrentUser>();
const propertyIconId = ref(-1);
const contactIconId = ref(-1);
const contactToBePeeked = ref(0);
const contactPeekTitle = ref("");
const displayContactPeekModal = ref(false);
const propertyToBePeeked = ref(0);
const propertyPeekTitle = ref("");
const displayPropertyPeekModal = ref(false);

onMounted(async () => {
  currentUser.value = await currentUserStore.getCurrentUserDetails();
});

// These handle row selection
const onRowSingleClick = (row: PaymentRunListItem) => {
  emit("rowSingleClick", row);
};

const onRowDoubleClicked = (row: PaymentRunListItem) => {
  emit("rowDoubleCLick", row);
};

// Logic for display peep icons and peek modals
const displayPropertyIcon = (id: number) => {
  propertyIconId.value = id;
};

const hidePropertyIcon = () => {
  propertyIconId.value = -1;
};

const peekProperty = (propertyId: number, propertyAddress: string) => {
  propertyToBePeeked.value = propertyId;
  propertyPeekTitle.value = propertyAddress;
  displayPropertyPeekModal.value = true;
};

const displayContactIcon = (id: number) => {
  contactIconId.value = id;
};

const hideContactIcon = () => {
  contactIconId.value = -1;
};

const showPeek = (contactId: number, contactName: string) => {
  contactToBePeeked.value = contactId;
  contactPeekTitle.value = contactName;
  displayContactPeekModal.value = true;
};

// Allows users to include rows to be processed in the payment run
const onIncludeChanged = (payment: PaymentRunListItem) => {
  nextTick();
  payment.include = !payment.include;
};

// Sets the total values to be displayed under the grid
const totalAmountToPay = computed(() => {
  return formatNumberIntoCurrency(
    props.payments.reduce((total, payment) => total + payment.amountToPay, 0),
    currentUser.value?.countryCodeID,
  );
});

const selectedPaymentsCount = computed(() => {
  return props.payments.filter((payment) => payment.include).length.toString();
});

const selectedTotalAmountToPay = computed(() => {
  return formatNumberIntoCurrency(
    props.payments
      .filter((payment) => payment.include)
      .reduce((total, payment) => total + payment.amountToPay, 0),
    currentUser.value?.countryCodeID,
  );
});

// These emit the selected bank account and contact type to the parent component so their descriptions can be accessed for processing the payments
const contactTypeSelected = (e: string) => {
  emit("contactTypeSelected", e);
};

const bankAccountSelected = (e: string) => {
  emit("bankAccountSelected", e);
};

// Menu item click
const onMenuItemClick = (e: ContextMenuItem) => {
  emit("menuItemSelected", e);
};

// Other
const fieldWidths = computed(() => {
  if (screen.width < 769) {
    return FieldSize.Full;
  }
  return FieldSize.Medium;
});

const contactLookupWidth = computed(() => {
  if (screen.width < 769) {
    return FieldSize.Full;
  }
  return FieldSize.Large;
});

const disableFiltersAndDropDownMenu = computed(() => {
  return props.loading || props.processSuccessful;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(LookupSingleSelect, {
        modelValue: paymentMethod.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((paymentMethod).value = $event)),
        label: "Payment Method",
        lookupSource: _unref(LookupTableSource).PaymentMethods,
        width: fieldWidths.value,
        "read-only": disableFiltersAndDropDownMenu.value
      }, null, 8, ["modelValue", "lookupSource", "width", "read-only"]),
      _createVNode(FieldValidationFreeDateBox, {
        modelValue: paymentDate.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((paymentDate).value = $event)),
        label: "Payment Date",
        width: fieldWidths.value,
        "min-date": new Date(),
        "read-only": disableFiltersAndDropDownMenu.value
      }, null, 8, ["modelValue", "width", "min-date", "read-only"]),
      _createVNode(LookupSingleSelect, {
        modelValue: selectedFilters.value.siteId,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedFilters.value.siteId) = $event)),
        label: "Branch",
        lookupSource: _unref(LookupTableSource).Sites,
        width: fieldWidths.value,
        "read-only": disableFiltersAndDropDownMenu.value
      }, null, 8, ["modelValue", "lookupSource", "width", "read-only"]),
      _createVNode(SystemCodeSingleSelect, {
        modelValue: selectedFilters.value.contactType,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((selectedFilters.value.contactType) = $event)),
        "code-type": _unref(CodeType).ContactType,
        width: fieldWidths.value,
        label: "Contact Type",
        "read-only": disableFiltersAndDropDownMenu.value,
        onValueChanged: contactTypeSelected
      }, null, 8, ["modelValue", "code-type", "width", "read-only"]),
      _createVNode(LookupSingleSelect, {
        modelValue: selectedFilters.value.bankAccountId,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((selectedFilters.value.bankAccountId) = $event)),
        label: "Bank Account",
        "read-only": disableFiltersAndDropDownMenu.value,
        lookupSource: _unref(LookupTableSource).BankAccounts,
        width: fieldWidths.value,
        onValueChanged: bankAccountSelected
      }, null, 8, ["modelValue", "read-only", "lookupSource", "width"]),
      _createVNode(SystemCodeSingleSelect, {
        modelValue: selectedFilters.value.paymentExportFormat,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((selectedFilters.value.paymentExportFormat) = $event)),
        "code-type": _unref(CodeType).PaymentExportFileFormat,
        label: "Payment Export Format",
        width: fieldWidths.value,
        "read-only": disableFiltersAndDropDownMenu.value
      }, null, 8, ["modelValue", "code-type", "width", "read-only"]),
      _createVNode(ContactLookup, {
        modelValue: selectedFilters.value.landlordId,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((selectedFilters.value.landlordId) = $event)),
        fetchInitialName: false,
        label: "Specific Contact",
        showClearIcon: true,
        showSearch: true,
        showNavigateContactIcon: false,
        width: contactLookupWidth.value,
        "read-only": disableFiltersAndDropDownMenu.value,
        "display-peek": true,
        typeToFind: _unref(DefaultContactType).Landlord
      }, null, 8, ["modelValue", "width", "read-only", "typeToFind"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      (__props.menuItems && __props.menuItems.length > 0)
        ? (_openBlock(), _createBlock(GridMenu, {
            key: 0,
            "menu-items": __props.menuItems,
            onItemClicked: onMenuItemClick,
            class: "grid-menu-button",
            id: "payment-run-modal-grid",
            atPosition: "bottom right",
            myPosition: "top right",
            "disabled:loading": props.loading
          }, null, 8, ["menu-items", "disabled:loading"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(GridBase, {
        "data-source": props.payments,
        "id-column-name": "id",
        loading: props.loading,
        "show-action-button": true,
        onRowClick: onRowSingleClick,
        onRowSelected: onRowDoubleClicked,
        wordWrapEnabled: true,
        "run-export": exportGrid.value,
        "onUpdate:runExport": _cache[7] || (_cache[7] = ($event: any) => ((exportGrid).value = $event)),
        "show-search-panel": false,
        customColumnSlots: [
        'includeCell',
        'propertyCell',
        'contactCell',
        'amountCell',
        'taxCell',
        'floatCell',
        'warningsCell',
        'balanceCell',
        'rentArrearsCell',
      ]
      }, {
        columns: _withCtx(() => [
          _createVNode(_unref(DxColumn), {
            "data-field": "id",
            caption: "ID",
            visible: false
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "contact",
            caption: "Contact",
            width: "150px",
            "hiding-priority": 11,
            "cell-template": "contactCell"
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "property",
            caption: "Property",
            "hiding-priority": 10,
            "cell-template": "propertyCell",
            width: "150px"
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "lastPaymentDate",
            "data-type": "date",
            caption: "Last Payment Date",
            width: "85px",
            "hiding-priority": 9,
            format: "dd/MM/yyyy"
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "rentDueDay",
            caption: "Rent Due Day",
            "hiding-priority": 8,
            width: "100px"
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "rentArrears",
            caption: "Rent Arrears",
            "hiding-priority": 7,
            width: "100px",
            "cell-template": "rentArrearsCell"
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "warnings",
            caption: "Warnings",
            "cell-template": "warningsCell",
            "hiding-priority": 6
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "referenceChequeNo",
            caption: "References/Cheque No.",
            "hiding-priority": 5,
            width: "100px"
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "balance",
            caption: "Balance",
            "cell-template": "balanceCell",
            "hiding-priority": 5,
            width: "100px"
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "floatToRetain",
            "cell-template": "floatCell",
            caption: "Float To Retain",
            "hiding-priority": 4,
            width: "100px"
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "taxToDeduct",
            "cell-template": "taxCell",
            caption: "Tax To Deduct",
            "hiding-priority": 3,
            width: "100px"
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "amountToPay",
            "cell-template": "amountCell",
            caption: "Amount To Pay",
            "hiding-priority": 2
          }),
          _createVNode(_unref(DxColumn), {
            "data-field": "include",
            caption: "Include",
            width: "125px",
            "hiding-priority": 12,
            "cell-template": "includeCell"
          })
        ]),
        includeCellData: _withCtx(({ data }) => [
          _createElementVNode("div", {
            class: "include-cell",
            onClick: () => onIncludeChanged(data)
          }, [
            _createVNode(SwitchToggle, {
              "model-value": data.include,
              "read-only": data.pause || __props.processSuccessful
            }, null, 8, ["model-value", "read-only"])
          ], 8, _hoisted_4)
        ]),
        propertyCellData: _withCtx(({ data }) => [
          _createElementVNode("div", {
            class: "property-cell",
            onMouseover: ($event: any) => (displayPropertyIcon(data.id)),
            onMouseleave: hidePropertyIcon
          }, [
            (propertyIconId.value == data.id)
              ? (_openBlock(), _createElementBlock("i", {
                  key: 0,
                  onClick: ($event: any) => (peekProperty(data.propertyId, data.property)),
                  class: "fas fa-user"
                }, null, 8, _hoisted_6))
              : _createCommentVNode("", true),
            _createTextVNode(" " + _toDisplayString(data.property), 1)
          ], 40, _hoisted_5)
        ]),
        contactCellData: _withCtx(({ data }) => [
          _createElementVNode("div", {
            class: "contact-cell",
            onMouseover: ($event: any) => (displayContactIcon(data.id)),
            onMouseleave: hideContactIcon
          }, [
            (contactIconId.value == data.id)
              ? (_openBlock(), _createElementBlock("i", {
                  key: 0,
                  onClick: ($event: any) => (showPeek(data.contactId, data.contact)),
                  class: "fas fa-user"
                }, null, 8, _hoisted_8))
              : _createCommentVNode("", true),
            _createTextVNode(" " + _toDisplayString(data.contact), 1)
          ], 40, _hoisted_7)
        ]),
        amountCellData: _withCtx(({ data }) => [
          _createElementVNode("div", null, _toDisplayString(_unref(formatNumberIntoCurrency)(
              data.amountToPay,
              currentUser.value?.countryCodeID,
            )), 1)
        ]),
        floatCellData: _withCtx(({ data }) => [
          _createElementVNode("div", null, _toDisplayString(_unref(formatNumberIntoCurrency)(
              data.floatToRetain,
              currentUser.value?.countryCodeID,
            )), 1)
        ]),
        taxCellData: _withCtx(({ data }) => [
          _createElementVNode("div", null, _toDisplayString(_unref(formatNumberIntoCurrency)(
              data.taxToDeduct,
              currentUser.value?.countryCodeID,
            )), 1)
        ]),
        balanceCellData: _withCtx(({ data }) => [
          _createElementVNode("div", null, _toDisplayString(_unref(formatNumberIntoCurrency)(data.balance, currentUser.value?.countryCodeID)), 1)
        ]),
        rentArrearsCellData: _withCtx(({ data }) => [
          _createElementVNode("div", null, _toDisplayString(_unref(formatNumberIntoCurrency)(
              data.rentArrears,
              currentUser.value?.countryCodeID,
            )), 1)
        ]),
        warningsCellData: _withCtx(({ data }) => [
          _createElementVNode("div", _hoisted_9, [
            (data.pause)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, "Payments Paused"))
              : _createCommentVNode("", true),
            _createTextVNode(" " + _toDisplayString(data.warnings), 1)
          ])
        ]),
        _: 1
      }, 8, ["data-source", "loading", "run-export"])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createTextVNode(" Payments Found "),
        _createVNode(AcquaintInfoBox, {
          label: "",
          text: String(__props.payments.length),
          width: _unref(FieldSize).Small
        }, null, 8, ["text", "width"]),
        _createVNode(AcquaintInfoBox, {
          label: "",
          text: totalAmountToPay.value,
          width: _unref(FieldSize).Medium
        }, null, 8, ["text", "width"])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createTextVNode(" Selected Payment Total "),
        _createVNode(AcquaintInfoBox, {
          label: "",
          text: selectedPaymentsCount.value,
          width: _unref(FieldSize).Small
        }, null, 8, ["text", "width"]),
        _createVNode(AcquaintInfoBox, {
          label: "",
          text: selectedTotalAmountToPay.value,
          width: _unref(FieldSize).Medium
        }, null, 8, ["text", "width"])
      ]),
      _createVNode(ContactsPeekPopup, {
        modelValue: displayContactPeekModal.value,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((displayContactPeekModal).value = $event)),
        "contact-id": contactToBePeeked.value,
        title: contactPeekTitle.value
      }, null, 8, ["modelValue", "contact-id", "title"]),
      _createVNode(PropertyPeekModal, {
        modelValue: displayPropertyPeekModal.value,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((displayPropertyPeekModal).value = $event)),
        "property-id": propertyToBePeeked.value,
        title: propertyPeekTitle.value
      }, null, 8, ["modelValue", "property-id", "title"])
    ])
  ], 64))
}
}

})